import React, { useContext, useEffect, useRef, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import MenuTop from "../../components/MenuTop/MenuTop";
import { DocumentTypeContext } from "../../context/DocumentContext";
import { To, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { usePrompt } from "../../utils/usePrompt";
import { Button } from "reactstrap";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useToast } from "../../context/ToastContext";
import Joyride, { Step } from "react-joyride";
import { FaTrashAlt } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import { ContactContext } from "../../context/ContactContext";
import { jwtDecode } from "jwt-decode";
import ModaMobileLogin from "../../components/ModaMobileLogin/ModaMobileLogin";
import "./AddSignatories.css";
import InputMask from "react-input-mask";
import { MaskedPhoneInput } from "../../components/Inputs/IMaskInput";

export const CustomTextField = styled(TextField)({
  "& label": {
    color: "#75788D",
  },
  "& label.Mui-focused": {
    color: "#F9B233",
  },
  "& .MuiInput-underline:before": {
    borderBottomColor: "#e0e0e0",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottomColor: "#F9B233",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#F9B233",
  },
});

const AddSignatories: React.FC = () => {
  const {
    getDocumentSign,
    getSignersEdit,
    setNameDocument,
    setIdEditDocument,
    nameDocument,
    collaborators,
    setCollaborators,
    signersEdit,
    setTutorial,
    tutorial,
    tableDocuments,
  } = useContext(DocumentTypeContext);
  const { getContactByEmail } = useContext(ContactContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isDirty, setIsDirty] = useState(true);
  const showToast = useToast();
  const [newCollaborator, setNewCollaborator] = React.useState("");
  const [newCollaboratorName, setNewCollaboratorName] = useState("");
  const [newCollaboratorPhoneNumber, setNewCollaboratorPhoneNumber] =
    useState("");
  const [countryCode, setCountryCode] = useState("+55");
  const [addToContacts, setAddToContacts] = useState(true);
  const [sendMessageWhatsApp, setSendMessageWhatsApp] = useState(false);
  const [requireSignerDocument, setRequireSignerDocument] = useState(false);
  const [selectedFieldType, setSelectedFieldType] = React.useState("email");
  const [emailOptions, setEmailOptions] = useState<any[]>([]);
  const [emailDatabase, setEmailDatabase] = useState<any[]>([]);
  const [sequentialSigning, setSequentialSigning] = useState(false);

  const isValidEmail = (email: any) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone: any) => /^\(\d{2}\) \d{5}-\d{4}$/.test(phone);
  const containerRef = useRef(null);

  const params = new URLSearchParams(location.search);
  const documentId = params.get("edit");

  let objUserTk;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }

  const handleAddCollaborator = () => {
    if (newCollaboratorName.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Por favor, insira um nome válido.",
      });
      return;
    }

    if (sendMessageWhatsApp) {
      const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
      const codeRegex = /^\+\d{1,3}$/;

      if (!codeRegex.test(countryCode) || !phoneRegex.test(newCollaboratorPhoneNumber)) {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Para enviar uma mensagem no WhatsApp, informe o código do país e um número de telefone completo e válido com DDD.",
        });
        return;
      }
    }

    const isValidInput =
      (selectedFieldType === "email" && isValidEmail(newCollaborator.trim())) ||
      (selectedFieldType === "phone" && isValidPhone(newCollaborator.trim()));

    if (isValidInput) {
      const fullPhone = newCollaboratorPhoneNumber
        ? `${countryCode} ${newCollaboratorPhoneNumber}`
        : "";
      setCollaborators([
        ...collaborators,
        {
          id: collaborators.length + 2,
          name: newCollaboratorName,
          email: newCollaborator,
          phoneNumber: fullPhone,
          addToContacts: addToContacts,
          sendMessageWhatsApp: sendMessageWhatsApp,
          requireSignerDocument: requireSignerDocument,
          signature: "",
          date: "",
          fieldType: selectedFieldType,
        },
      ]);

      setNewCollaborator("");
      setNewCollaboratorName("");
      setNewCollaboratorPhoneNumber("");

      setTimeout(() => {
        if (containerRef.current) {
          //@ts-ignore
          containerRef.current.scrollTo({
            //@ts-ignore
            top: containerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 100);
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: `Por favor, insira um ${
          selectedFieldType === "email" ? "e-mail" : "número de telefone"
        } válido.`,
      });
    }
  };

  const handleNavigate = () => {
    console.log("col", collaborators);
    if (!nameDocument) {
      showToast("info", "Nome do documento não pode ser vazio");
      return;
    }
    if (collaborators.length === 0) {
      showToast("info", "Adicione pelo menos 1 signatário");
      return;
    }

    if (sequentialSigning) {
      const N = collaborators.length;

      const rawPositions = collaborators.map((c: any) => c.signPosition);

      if (
        rawPositions.some((p: any) => p === "" || p === undefined || p === null)
      ) {
        showToast(
          "info",
          "Preencha a posição na fila para todos os signatários."
        );
        return;
      }

      const positions = rawPositions.map((p: any) => Number(p));
      if (positions.some((p: any) => !Number.isInteger(p) || p < 1 || p > N)) {
        showToast("info", `Posições devem ser inteiras entre 1 e ${N}.`);
        return;
      }

      if (new Set(positions).size !== N) {
        showToast("info", "Posições na fila não podem se repetir.");
        return;
      }
    }

    let path = "/admin/create-documents";

    if (documentId) {
      path += `?edit=${documentId}`;
    }

    navigate(path);
  };

  const handleDeleteCollaborator = (index: any) => {
    const updatedCollaborators = [...collaborators];
    updatedCollaborators.splice(index, 1);
    setCollaborators(updatedCollaborators);
  };

  const handleJoyrideCallback = (data: any) => {
    const { status } = data;
    if (status === "finished" || status === "skipped") {
      setTutorial(false);
    }
  };

  const steps: Step[] = [
    {
      target: "#document-name-input",
      content: "Digite o nome do documento a ser assinado.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-name-input",
      content: "Digite o nome do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-email-input",
      content: "Digite o e-mail do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#signer-phone-input",
      content: "Insira o telefone do signatário.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#add-to-contacts-checkbox",
      content:
        "Marque esta opção se deseja salvar este signatário em seus contatos.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "#add-to-required-document",
      content:
        "Marque esta opção se deseja solicitar um documento do signatário ao assinar.",
      placement: "right",
      disableBeacon: true,
    },
    {
      target: "#add-signatario-button",
      content: "Clique aqui para adicionar o signatário à lista.",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: "#next-document",
      content: "Após adicionar os signatários, clique aqui para continuar.",
      placement: "left",
      disableBeacon: true,
    },
  ];

  useEffect(() => {
    const fetchEmails = async () => {
      if (newCollaborator.length >= 3) {
        try {
          const response = await getContactByEmail(
            newCollaborator,
            objUserTk.UserId
          );

          console.log("response", response);
          if (response && Array.isArray(response)) {
            setEmailOptions(response.map((user: any) => user.email));
            setEmailDatabase(response);
          }
        } catch (error) {
          console.error("Erro ao buscar contatos:", error);
        }
      } else {
        setEmailOptions([]);
      }
    };

    fetchEmails();
  }, [newCollaborator]);

  const handleSelectEmail = (
    event: React.SyntheticEvent,
    selectedEmail: string | null
  ) => {
    if (selectedEmail) {
      const user = emailDatabase.find((user) => user.email === selectedEmail);
      console.log("user", user);
      if (user) {
        setNewCollaborator(user.email);
        setNewCollaboratorName(user.name);
        if (user.phoneNumber) {
          const match = user.phoneNumber.match(/^(\+\d{1,3})\s*(.*)$/);
          if (match) {
            setCountryCode(match[1]);
            setNewCollaboratorPhoneNumber(match[2]);
          } else {
            setNewCollaboratorPhoneNumber(user.phoneNumber);
          }
        } else {
          setNewCollaboratorPhoneNumber("");
        }
      }
    }
  };

  function handleSignPositionChange(idx: number, value: string) {
    const raw = value.trim();
    const n = raw === "" ? "" : Number(raw);

    setCollaborators((prev: any) =>
      prev.map((c: any, i: any) =>
        i === idx
          ? {
              ...c,
              signPosition:
                raw === ""
                  ? ""
                  : Math.max(
                      1,
                      Math.min(
                        prev.length,
                        isNaN(Number(n)) ? 1 : Math.floor(Number(n))
                      )
                    ),
            }
          : c
      )
    );
  }

  function autoFillPositions() {
    setCollaborators((prev: any) =>
      prev.map((c: any, i: any) => ({ ...c, signPosition: i + 1 }))
    );
  }

  function clearPositions() {
    setCollaborators((prev: any) =>
      prev.map((c: any) => {
        const { signPosition, ...rest } = c;
        return rest;
      })
    );
  }

  useEffect(() => {
    var url = window.location.href;

    var urlObj = new URL(url);

    var documentId = urlObj.searchParams.get("edit");

    const getDocument = async () => {
      if (documentId) {
        setIdEditDocument(documentId);
        await getDocumentSign(documentId);
        await getSignersEdit(documentId);
      }
    };
    getDocument();
  }, []);

  useEffect(() => {
    if (signersEdit && documentId) {
      const uniqueCollaborators = Array.from(
        new Map(
          signersEdit.map((item: any, index: number) => [
            item.email,
            {
              id: index + 1,
              name: item.text,
              email: item.email,
              addToContacts: item.addToContacts,
              sendMessageWhatsApp: item.sendMessageWhatsApp,
              phoneNumber: item.phoneNumber,
            },
          ])
        ).values()
      );

      setCollaborators(uniqueCollaborators);
    }
  }, [signersEdit]);

  useEffect(() => {
    if (tableDocuments.length === 0) {
      setTutorial(true);
    }
  }, []);

  usePrompt(
    "Você tem certeza que deseja sair? Todas as alterações feitas no documento serão perdidas.",
    isDirty
  );

  const muiTheme = createTheme({
    palette: { primary: { main: "#F9B233" } },
  });

  return (
    <>
      <ModaMobileLogin />
      <Joyride
        steps={steps}
        run={tutorial}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          last: "Finalizar",
          next: "Próximo",
          back: "Voltar",
          skip: "Pular",
          close: "Fechar",
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#F9B233",
            textColor: "#333",
            arrowColor: "#fff",
            backgroundColor: "#fff",
          },
        }}
      />

      <LoadingSpinner />

      <MenuTop />
      <ThemeProvider theme={muiTheme}>
      <div className="add-sig-container">
        {/* Nome do documento */}
        <CustomTextField
          value={nameDocument}
          onChange={(e) => setNameDocument(e.target.value)}
          id="document-name-input"
          label="Nome do Documento"
          variant="standard"
          fullWidth
        />

        {/* Formulário de signatário */}
        <div className="sig-form-section">
          <h3 className="add-signatory-title">Adicionar signatário</h3>

          <div className="sig-form-row" style={{ marginTop: 20 }}>
            <Autocomplete
              key={collaborators.length}
              freeSolo
              options={emailOptions}
              onInputChange={(event, newValue) => setNewCollaborator(newValue)}
              onChange={handleSelectEmail}
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  value={newCollaborator}
                  label="E-mail"
                  variant="standard"
                  fullWidth
                />
              )}
            />
            <CustomTextField
              value={newCollaboratorName}
              onChange={(e) => setNewCollaboratorName(e.target.value)}
              id="signer-name-input"
              label="Nome do signatário"
              variant="standard"
              fullWidth
            />
          </div>

          <div className="sig-form-row" style={{ marginTop: 16 }}>
            <div style={{ maxWidth: 320 }}>
              <MaskedPhoneInput
                value={newCollaboratorPhoneNumber}
                onChange={(e) => setNewCollaboratorPhoneNumber(e.target.value)}
                countryCode={countryCode}
                onCountryCodeChange={(e) => setCountryCode(e.target.value)}
              />
            </div>
          </div>

          <div className="sig-options" style={{ marginTop: 16 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={addToContacts}
                  onChange={(e) => setAddToContacts(e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label="Salvar nos contatos"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={sendMessageWhatsApp}
                  onChange={(e) => setSendMessageWhatsApp(e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label="Notificar via WhatsApp"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={requireSignerDocument}
                  onChange={(e) => setRequireSignerDocument(e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label="Requerer documento"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={sequentialSigning}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setSequentialSigning(checked);
                    if (checked) {
                      autoFillPositions();
                    } else {
                      clearPositions();
                    }
                  }}
                  color="primary"
                  size="small"
                />
              }
              label="Ordem sequencial"
            />
          </div>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button
              id="add-signatario-button"
              className="btn-add-signatory"
              onClick={handleAddCollaborator}
            >
              + Adicionar Signatário
            </Button>
          </div>
        </div>

        {/* Lista de signatários */}
        {collaborators.length > 0 && (
          <div className="sig-cards-grid">
            {collaborators.map((collaborator: any, index: number) => (
              <div className="sig-card" key={index}>
                <div className="sig-card-header">
                  <span className="sig-card-number">#{index + 1}</span>
                  <Button
                    className="sig-card-remove"
                    onClick={() => handleDeleteCollaborator(index)}
                  >
                    <FaTrashAlt size={14} />
                  </Button>
                </div>

                <div className="sig-card-info">
                  <span className="sig-card-name">{collaborator.name}</span>
                  <span className="sig-card-email">{collaborator.email}</span>
                  {collaborator.phoneNumber && (
                    <span className="sig-card-phone">{collaborator.phoneNumber}</span>
                  )}
                </div>

                {sequentialSigning && (
                  <div className="sig-card-position">
                    <CustomTextField
                      label="Posição na fila"
                      type="number"
                      variant="outlined"
                      size="small"
                      value={collaborator.signPosition ?? ""}
                      onChange={(e) =>
                        handleSignPositionChange(index, e.target.value)
                      }
                      inputProps={{ min: 1, max: collaborators.length }}
                      style={{ width: 130 }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Botão continuar */}
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            id="next-document"
            className="btn-continue"
            onClick={handleNavigate}
          >
            Continuar
            <ArrowForwardIcon style={{ marginLeft: 8 }} />
          </Button>
        </div>
      </div>
      </ThemeProvider>
    </>
  );
};

export default AddSignatories;
